//Comentario necesario para codificación en UTF-8, ver Inc6743
angular.module("pphhApp").controller("SecurityController", 
		["$scope", "SecurityService", SecurityController]);

function SecurityController($scope, securityService) {
	
	$scope.user = {};
	
	$scope.init = function () {
		securityService.getCurrentUser()
		.then(function (response) {
			var user = response.data;
			if(user) {
				if(user.lastLogin) {
					user.lastLogin = moment(user.lastLogin).toDate();
				}
				$scope.user = user;
			}
		});
	};
}